import { add as hasAdd } from '@dojo/framework/core/has';

const isMicro = /mme/.test(window.location.pathname);

hasAdd('dev-build', !/partnerrc|hclspstaging/.test(window.location.hostname));
hasAdd('quiz-progress-chart', !isMicro);
hasAdd('use-landing-page', !isMicro);
hasAdd('use-alternate-next', true);
hasAdd('use-alternate-pass-view', true);
hasAdd('use-assessment-chooser', !isMicro);
hasAdd('use-audio-topics', true);
hasAdd('use-carousel-view', !isMicro);
hasAdd('use-cutscores', false);
// hasAdd('use-ml-study-plan', true);
hasAdd('use-search-in-heading', true);
hasAdd('use-study-plan', !isMicro);
hasAdd('use-xapi', true);
hasAdd('use-topicgroup-reading', true);
hasAdd('use-topicgroup-quiz', false);
hasAdd('practice-exam', true);
hasAdd('posttest', true);
hasAdd('ati-use-single-rpc', true);
hasAdd('no-explore-assess', isMicro);
hasAdd('use-toc', !isMicro);
hasAdd('use-wylo', !isMicro);
// Micro-credential specific flags
hasAdd('use-micro-view', isMicro);
hasAdd('use-alternate-header', isMicro);
hasAdd('use-alternate-footer', isMicro);
hasAdd('use-png-badge-logo', isMicro);
hasAdd('use-svg-header-image', isMicro);
hasAdd('use-svg-card-header-images', isMicro);
